"use client";

import { useEffect, useState } from "react";

function elapsedLabel(seconds: number) {
  if (seconds < 1) return "不到 1 秒";
  if (seconds < 60) return `${seconds} 秒`;
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return remainder ? `${minutes} 分 ${remainder} 秒` : `${minutes} 分钟`;
}

export function LoadingActivityPanel({
  operation,
  waitingFor = "服务器返回页面数据",
}: {
  operation: string;
  waitingFor?: string;
}) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [online, setOnline] = useState(true);

  useEffect(() => {
    const startedAt = Date.now();
    const updateElapsed = () => setElapsedSeconds(Math.floor((Date.now() - startedAt) / 1_000));
    const updateConnection = () => setOnline(window.navigator.onLine);
    updateElapsed();
    updateConnection();
    const timer = window.setInterval(updateElapsed, 1_000);
    window.addEventListener("online", updateConnection);
    window.addEventListener("offline", updateConnection);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("online", updateConnection);
      window.removeEventListener("offline", updateConnection);
    };
  }, []);

  const status = !online
    ? "网络已断开，等待连接恢复"
    : elapsedSeconds >= 20
      ? `等待时间较长，${waitingFor}可能受阻`
      : elapsedSeconds >= 8
        ? `请求仍未完成，继续等待${waitingFor}`
        : `请求已发出，等待${waitingFor}`;

  return <aside className="qy-loading-activity" aria-label="当前处理信息">
    <header><i aria-hidden="true" /><strong>当前处理</strong></header>
    <dl>
      <div><dt>操作</dt><dd>{operation}</dd></div>
      <div><dt>状态</dt><dd>{status}</dd></div>
      <div><dt>已等待</dt><dd>{elapsedLabel(elapsedSeconds)}</dd></div>
      <div><dt>网络</dt><dd data-online={online}>{online ? "在线" : "离线"}</dd></div>
    </dl>
    {elapsedSeconds >= 20 ? <p role="status">若持续不变，请截图此面板；刷新页面也不会修改资产数据。</p> : null}
  </aside>;
}
